/**
 * JotAuditPageWrapper Component
 *
 * Conditionally renders either the full JotAuditPage or the "coming soon" AuditPage
 * based on the payer_template_note_processing or jotaudit feature flag
 */

import React from 'react';

import { AuditComingSoonPage } from './AuditComingSoonPage';
import { useAuditEnabled } from './hooks';
import { JotAuditPage } from './JotAuditPage';

export const JotAuditPageWrapper: React.FC = () => {
  const isAuditEnabled = useAuditEnabled();

  if (isAuditEnabled) {
    return <JotAuditPage />;
  }

  return <AuditComingSoonPage />;
};

export default JotAuditPageWrapper;
